import { appRoutes, commonButtonMessages, insertSecondaryPhoneNumberUserRegistrationMessages, useInsertSecondaryPhoneNumberPageLogic, isValidPhone } from 'azshared';
import React, { FormEvent, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AppButton, AppButtonType, AppButtonVariant } from '../../../../components/buttons/app-button';
import { Card } from '../../../../components/card/card';
import { AppInputText } from '../../../../components/input-text/app-input-text';
import { AppLink } from '../../../../components/labels/app-link';
import { useGlobalActions, useGoToLoginFromRegistration } from '../../../../hooks/global-actions';
import { LoginContainer } from '../../login-container/login-container';
import { SearchablePrefixPicker } from '../../../../components/searchable-prefix-picker/searchable-prefix-picker';
import './phone-number-user-registration-page.scss';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';
import { useNavigate } from 'react-router-dom';

export const InsertSecondaryPhoneNumberUserRegistrationPage = () => {
  const { formatMessage } = useIntl();
  const goToLoginFromRegistration = useGoToLoginFromRegistration();
  const globalActions = useGlobalActions();

  const { buttonDisabled, phoneNumber, insertPhoneNumberRequestStatus, handleSubmit, updatePhoneNumber, handleSkip } = useInsertSecondaryPhoneNumberPageLogic(
    useGlobalActions()
  );
  const navigate = useNavigate();
  const handleClickGoBack = useCallback(() => {
    navigate(appRoutes.InsertPhoneNumberUserRegistration);
  }, [navigate]);

  const onSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (!isValidPhone(phoneNumber)) {
        globalActions.showToast({
          type: 'error',
          title: formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.errorInvalidPhoneNumberFormat),
          close: globalActions.closeToast
        });
        return;
      }
      handleSubmit();
    },
    [handleSubmit, formatMessage, globalActions, phoneNumber]
  );

  return (
    <div>
      <LoginContainer>
        <div className='insert-phone-number-user-registration-page'>
          <Card
            title={formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.pageTitle)}
            subtitle={formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.pageSubtitle)}
            clickGoBack={handleClickGoBack}
            back={formatMessage(commonButtonMessages.backLink)}>
            <form onSubmit={onSubmit}>
              <div className='phone-number-input-row-container'>
                <label className='phone-number-input-label'>
                  {formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.labelInsertPhoneNumberInputText)}
                </label>
                <SearchablePrefixPicker
                  placeholder={formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.placeholderInsertPhoneNumberInputText)}
                  value={phoneNumber}
                  onChange={updatePhoneNumber}
                />
              </div>

              <div className='button'>
                <AppButton
                  className={'button-ok'}
                  label={formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.buttonSendCodeByPhone)}
                  type={AppButtonType.SUBMIT}
                  disabled={buttonDisabled}
                  loading={insertPhoneNumberRequestStatus === 'loading'}
                />
                <AppButton
                  label={formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.buttonSkip)}
                  variant={AppButtonVariant.Secondary}
                  disabled={insertPhoneNumberRequestStatus === 'loading'}
                  onClick={handleSkip}
                />
              </div>
            </form>
            <div className='description-disclaimer insert-phone-number'>
              {formatMessage(insertSecondaryPhoneNumberUserRegistrationMessages.descriptionDisclaimerInsertPhoneNumber)}
            </div>
            <div className='disclaimer'>
              {formatMessage(commonButtonMessages.linkBackToLogin)}
              <AppLink to={appRoutes.Login} replace={false} label={formatMessage(commonButtonMessages.linkToLogin)} onClick={goToLoginFromRegistration} />
            </div>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />
    </div>
  );
};
